import { render, staticRenderFns } from "./addAktaPerusahaan.vue?vue&type=template&id=7545a711&scoped=true&"
import script from "./addAktaPerusahaan.vue?vue&type=script&lang=js&"
export * from "./addAktaPerusahaan.vue?vue&type=script&lang=js&"
import style0 from "./addAktaPerusahaan.vue?vue&type=style&index=0&id=7545a711&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7545a711",
  null
  
)

export default component.exports